
(()=>{
  const mount=(root)=>{
    if(!root||root.dataset.bound==='true')return;
    root.dataset.bound='true';
    let destination;
    try{destination=new URL(root.dataset.destination)}catch{return}
    const host=destination.hostname.toLowerCase();
    const validHost=host==='mercadolibre.cl'||host.endsWith('.mercadolibre.cl')||host==='mercadolibre.com'||host.endsWith('.mercadolibre.com')||host==='mercadolibre.com.ec'||host.endsWith('.mercadolibre.com.ec');
    if(destination.protocol!=='https:'||!validHost||destination.username||destination.password)return;
    const preview=new URLSearchParams(location.search).has('preview_theme_id')||(window.Shopify&&window.Shopify.theme&&window.Shopify.theme.role!=='main');
    if(root.dataset.autoRedirect!=='true'||root.dataset.designMode==='true'||preview)return;
    const notice=root.querySelector('[data-redirect-notice]');
    const counter=root.querySelector('[data-redirect-count]');
    const cancel=root.querySelector('[data-cancel-redirect]');
    if(!notice||!counter||!cancel)return;
    let seconds=Math.max(10,Math.min(60,Number(root.dataset.delay)||20));
    counter.textContent=String(seconds);notice.hidden=false;
    const tick=setInterval(()=>{
      if(document.visibilityState==='hidden')return;
      seconds-=1;counter.textContent=String(seconds);
      if(seconds<=0){clearInterval(tick);location.assign(destination.href)}
    },1000);
    cancel.addEventListener('click',()=>{clearInterval(tick);notice.hidden=true},{once:true});
    root.addEventListener('click',(event)=>{if(event.target.closest('a[href^="#u-contact"],a[href^="mailto:"],summary')){clearInterval(tick);notice.hidden=true}});
    document.addEventListener('shopify:section:unload',()=>clearInterval(tick),{once:true});
  };
  document.querySelectorAll('[data-ubuntu-migration]').forEach(mount);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-ubuntu-migration]').forEach(mount));
})();
